export interface ProductTabSearchType {
    homeDisplayCategoryTitle: string;
    homeDisplayCategoryName: string;
    parentHomeDisplayCategoryName: string;
    availableDisplay: 'all' | 'true' | 'false';
    displayStatus: 'all' | 'true' | 'false';
}

export const productTabSearchInitState: ProductTabSearchType = {
    availableDisplay: 'all',
    displayStatus: 'all',
    homeDisplayCategoryName: '',
    homeDisplayCategoryTitle: '',
    parentHomeDisplayCategoryName: '',
};
